import { Component, Input } from "@angular/core";
import { Location } from "@angular/common";

@Component({
    selector: 'shared-detail-form-container',
    templateUrl: './detail-form-container.component.html',
    styleUrls: ['./detail-form-container.component.scss'],
    standalone: false
})
export class DetailFormContainerComponent {
  @Input() title = ''

  constructor(private location: Location) {
  }

  navigateBack() {
    this.location.back()
  }
}
